"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentTransferAccountType = void 0;
exports.paymentTransferAccountType = { "BANK_ACCOUNT": { "name": { "code": "bankAccount" } }, "CID_PROMPTPAY": { "name": { "code": "promptPayCID" } } };
